// removed by extract-text-webpack-plugin
module.exports = {"container":"_2FJIZMlY2Vm3v-d-wvaP1u","currency":"_1mx_1thHwNET94DlBAn-KJ","icon":"bK0F_mrlPftnFy7hTBzSi","content":"_3qoO0LY-SBtJoOfHxB6oxr","name":"_2VP-MVvy8NQW70Ee35lviR","description":"_1Tvy-ElFINoJP3VwuFOYga"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Nav/Products/styles.css
// module id = 1649
// module chunks = 83